/*
  Device toggle for the Xplora support page (sections/xplora-guide.liquid): shows the step
  list for the chosen device, names it in the heading and points the PDF link at its guide.
  "Show the steps" on a device card picks that device and scrolls to "Before you start".
*/
(function() {
  function init(root) {
    var pdfs = {
      one: root.getAttribute('data-pdf-one'),
      watch: root.getAttribute('data-pdf-watch')
    };
    var picks = root.querySelectorAll('[data-xplora-pick]');
    var deviceName = root.querySelector('[data-xplora-device-name]');
    var pdfLink = root.querySelector('[data-xplora-steps-pdf]');

    function setDevice(key) {
      if (!pdfs[key]) return;
      root.querySelectorAll('[data-xplora-steps]').forEach(function(list) {
        list.hidden = list.getAttribute('data-xplora-steps') !== key;
      });
      picks.forEach(function(button) {
        var active = button.getAttribute('data-xplora-pick') === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        // The toggle buttons carry the device names
        if (active && deviceName) deviceName.textContent = button.textContent.trim();
      });
      if (pdfLink) pdfLink.href = pdfs[key];
    }

    picks.forEach(function(button) {
      button.addEventListener('click', function() {
        setDevice(button.getAttribute('data-xplora-pick'));
      });
    });

    root.querySelectorAll('[data-xplora-show]').forEach(function(button) {
      button.addEventListener('click', function() {
        setDevice(button.getAttribute('data-xplora-show'));
        var target = root.querySelector('#before');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  document.querySelectorAll('[data-xplora]').forEach(init);
})();
